import axios from 'axios';

export const jwtToken = localStorage.getItem("authorization");

/*axios.interceptors.request.use(
  function(config) {

    if (jwtToken && config.url.indexOf("v1/signIn") === -1) {
      config.headers["authorization"] = "Bearer " + jwtToken;
    }

    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);*/


axios.interceptors.response.use(
  function(config) {
    return config;
  },
  function(err) {
    if (err.response.data.message === "Unauthorized path" && err.response.request.responseURL .indexOf("v1/signIn") === -1){
      window.location.href = "/"
    }else{
      
    }
    
  }
);